/*
 * SPDX-FileCopyrightText: © 2025 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

@import url('../shared.css');

:host {
  display: block;
}

:host(:focus-visible) {
  outline: var(--qds-theme-focus-border) solid var(--qds-focus-border-width);
  border-radius: var(--qds-focus-border-radius);
}

.qds-menu-item-container {
  display: flex;
  align-items: center;
}

.qds-disabled {
  opacity: var(--qds-theme-disabled);
  pointer-events: none;
  cursor: not-allowed;
}

.qds-icon {
  color: var(--qds-theme-text-standard);
}

.qds-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--qds-theme-title);
}

.qds-shortcut {
  color: var(--qds-theme-text-subdued);
}

[data-size='small'] {
  .qds-menu-item-container {
    min-height: var(--qds-list-item-small-height);
    gap: var(--qds-list-item-small-gap-internal);
    padding-inline: var(--qds-list-item-small-padding-horizontal);
  }

  .menu-item-checkable {
    height: var(--qds-control-small-icon-size);
    width: var(--qds-control-small-icon-size);
  }

  .qds-icon {
    font-size: var(--qds-control-small-icon-size);
  }

  .qds-main-icon {
    font-size: var(--qds-list-item-small-icon-size);
  }

  .qds-text {
    font: var(--qds-list-item-small-title);
  }
}

[data-size='standard'] {
  .qds-menu-item-container {
    min-height: var(--qds-list-item-standard-height);
    gap: var(--qds-list-item-standard-gap-internal);
    padding-inline: var(--qds-list-item-standard-padding-horizontal);
  }

  .menu-item-checkable {
    height: var(--qds-control-standard-icon-size);
    width: var(--qds-control-standard-icon-size);
  }

  .qds-icon {
    font-size: var(--qds-control-standard-icon-size);
  }

  .qds-main-icon {
    font-size: var(--qds-list-item-standard-icon-size);
  }

  .qds-text {
    font: var(--qds-list-item-standard-title);
  }
}

[data-size='large'] {
  .qds-menu-item-container {
    min-height: var(--qds-list-item-large-height);
    gap: var(--qds-list-item-large-gap-internal);
    padding-inline: var(--qds-list-item-large-padding-horizontal);
  }

  .menu-item-checkable {
    height: var(--qds-control-large-icon-size);
    width: var(--qds-control-large-icon-size);
  }

  .qds-icon {
    font-size: var(--qds-control-large-icon-size);
  }

  .qds-main-icon {
    font-size: var(--qds-list-item-large-icon-size);
  }

  .qds-text {
    font: var(--qds-list-item-large-title);
  }
}

.qds-menu-item {
  box-sizing: border-box;
  display: flex;
  flex-grow: 1;
  align-items: center;
  appearance: none;
  border: none;
  border-radius: var(--qds-control-border-radius);
  cursor: pointer;
  text-align: initial;
  text-decoration: none;
  color: var(--qds-theme-text-standard);

  &:not(.qds-selected, .qds-disabled) {
    &:hover {
      background-color: var(--qds-theme-interactive-background-hover);
    }

    &:active {
      background-color: var(--qds-theme-interactive-background-pressed);
    }
  }
}
